// extracted by mini-css-extract-plugin
module.exports = {"gradeIndicator":"bvSdxeF"};